import React from 'react'
import { Link } from "react-router-dom";

import swal from "sweetalert";
import homedashboard from "../../../../assets/images/homedashboard.svg";
import dashboardmenu from "../../../../assets/images/dashboardmenu.svg";
import offerdashboard from "../../../../assets/images/offerdashboard.svg";
import asktheexpertdashboard from "../../../../assets/images/asktheexpertdashboard.svg";
import articledashboard from "../../../../assets/images/articledashboard.svg";
import intarestdashboard from "../../../../assets/images/intarestdashboard.svg";
import accountsettingdashboard from "../../../../assets/images/accountsettingdashboard.svg";
import logoutdashboard from "../../../../assets/images/logoutdashboard.svg";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const SideBarsJsx = (props) => {
  const {t} =useTranslation()
  const history = useHistory();

  

  const logout = () => {
    swal({
      title: "Are you sure you want to Logout ?",
      icon: "warning",
      buttons: [
        'No',
        'Yes'
      ],
      dangerMode: true,
    }).then(function (isConfirm) {
      if (isConfirm) {
        localStorage.removeItem("token");
        localStorage.removeItem("loginAs");
        localStorage.removeItem("auth");
        localStorage.removeItem("masterID");
        localStorage.removeItem("expertId");
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("loginData");
        localStorage.removeItem("expertData");
        localStorage.removeItem("customerId");

        localStorage.removeItem("planName");
        localStorage.removeItem("legalName");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("description");
        localStorage.removeItem("flowName");
        localStorage.removeItem("flowType");
        localStorage.removeItem("subscriptionPlanId");
        localStorage.removeItem("planTypeID");
        localStorage.removeItem("planData");
        localStorage.removeItem("flowName");
        localStorage.removeItem("flowType");
        localStorage.removeItem("verificationStatus");
        localStorage.removeItem('VerifyInstituteID');
        localStorage.removeItem('AdminFlow');
        localStorage.removeItem('VerifyExpertID');
        localStorage.removeItem("comingFrom");

        history.push("/");
        window.location.reload()
      } else {
        //   swal("Cancelled", "Your imaginary file is safe :)", "error");
      }
    })

  }
  // {t("PRINT.TITLE")}
  return (
    <>
     <div className="dashboard-container maincustomerdashboard">
       <div className="dashboardleftpanel">
      <div className="text-column">
      {/* <div className="responsename">
        <div className="dashboardlogo">
          <img
            src={!response?.imageUrl
              ? `https://ui-avatars.com/api/?name=${response?.firstName}+${response?.lastName}&rounded=true`
              : `${NEW_URL}/${response?.imageUrl}`}
            alt={'icon'} 
          />
        </div>
        {`${response?.firstName} ${response?.lastName}`}
      </div> */}
      <div className="d-block d-lg-none d-sm-none d-md-none ">
      <nav className="navbar">
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"><img src={dashboardmenu} alt="menuicon"/></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarText">
      <ul className="navbar-nav dashboardinner">
         <li className="nav-item">
            <Link to={'/customerDashboard'} className={`${window.location.href?.toLowerCase().includes('customerdashboard') ? 'active' : ''}`}>
            <p className={`${window.location.href?.toLowerCase().includes('customerdashboard') ? 'activetext' : ''}`}> <span className="menusideimage"><img className="leftborder" src={homedashboard} alt={'icon'} /></span>  {t("customersidebar.HOME")}</p> 
            </Link>
          </li>
          <li className="nav-item">
            <Link to={'/suggestedoffer'}  className={`${window.location.href?.toLowerCase().includes('suggestedoffer') ? 'active' : ''}`}>
                <p className={`${window.location.href?.toLowerCase().includes('suggestedoffer') ? 'activetext' : ''}`}><span className="menusideimage"><img className="leftborder" src={offerdashboard} alt={'icon'} /></span> {t("customersidebar.OFFERS")}</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link to={'/customerAskTheExpert'} className={`${window.location.href?.toLowerCase().includes('customerasktheexpert') ? 'active' : ''}`}>
                <p className={`${window.location.href?.toLowerCase().includes('customerasktheexpert') ? 'activetext' : ''}`}><span className="menusideimage"><img className="leftborder" src={asktheexpertdashboard} alt={'icon'} /></span> {t("customersidebar.ASKTHEEXPERTS")}</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link to={'/customerBlogs'}  className={`${window.location.href?.toLowerCase().includes('customerblogs') ? 'active' : ''}`}>
               <p className={`${window.location.href?.toLowerCase().includes('customerblogs') ? 'activetext' : ''}`}> <span className="menusideimage"><img className="leftborder" src={articledashboard} alt={'icon'} /></span> {t("customersidebar.ARTICLES")}</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link to={'/customerInterest'} className={`${window.location.href?.toLowerCase().includes('customerinterest') ? 'active' : ''}`}>
               <p className={`${window.location.href?.toLowerCase().includes('customerinterest') ? 'activetext' : ''}`}> <span className="menusideimage"><img className="leftborder" src={intarestdashboard} alt={'icon'} /></span> {t("customersidebar.INTERESTS")}</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link to={'/customerAccounts'} className={`${window.location.href?.toLowerCase().includes('customeraccounts') ? 'active' : ''}`}>
               <p className={`${window.location.href?.toLowerCase().includes('customeraccounts') ? 'activetext' : ''}`}> <span className="menusideimage"><img className="leftborder" src={accountsettingdashboard} alt={'icon'} /></span> {t("customersidebar.ACCOUNTSETTING")}</p>
            </Link>
          </li>
          <li className="nav-item" onClick={logout}>
            <div className="sidebarlogout">
              <p><span className="menusideimage"><img className="leftborder" src={logoutdashboard} alt={'icon'} /></span> {t("customersidebar.LOGOUT")}</p>
            </div>
          </li>
        
      </ul>
    </div>

</nav>
      </div>
      <div className="dashboardlink dashboardtext mydash d-none d-sm-block">
        <ul className="dashboardinner">
          <li >
            <Link to={'/customerDashboard'}>
            <span className="menusideimage"><img className="leftborder" src={homedashboard} alt={'icon'} /></span>  <p className={`${window.location.href?.toLowerCase().includes('customerdashboard') ? 'activetext' : ''}`}>{t("customersidebar.HOME")}</p> 
            </Link>
          </li>
          <li >
            <Link to={'/suggestedoffer'}>
                <span className="menusideimage"><img className="leftborder" src={offerdashboard} alt={'icon'} /></span><p className={`${window.location.href?.toLowerCase().includes('suggestedoffer') ? 'activetext' : ''}`}>{t("customersidebar.OFFERS")}</p>
            </Link>
          </li>
          <li >
            <Link to={'/customerAskTheExpert'}>
                <span className="menusideimage"><img className="leftborder" src={asktheexpertdashboard} alt={'icon'} /></span><p className={`${window.location.href?.toLowerCase().includes('customerasktheexpert') ? 'activetext' : ''}`}>{t("customersidebar.ASKTHEEXPERTS")}</p>
            </Link>
          </li>
          <li >
            <Link to={'/customerBlogs'}>
               <span className="menusideimage"><img className="leftborder" src={articledashboard} alt={'icon'} /></span> <p className={`${window.location.href?.toLowerCase().includes('customerblogs') ? 'activetext' : ''}`}>{t("customersidebar.ARTICLES")}</p>
            </Link>
          </li>
          <li >
            <Link to={'/customerInterest'}>
               <span className="menusideimage"><img className="leftborder" src={intarestdashboard} alt={'icon'} /></span> <p className={`${window.location.href?.toLowerCase().includes('customerinterest') ? 'activetext' : ''}`}>{t("customersidebar.INTERESTS")}</p>
            </Link>
          </li>
          <li >
            <Link to={'/customerAccounts'}>
               <span className="menusideimage"><img className="leftborder" src={accountsettingdashboard} alt={'icon'} /></span> <p className={`${window.location.href?.toLowerCase().includes('customeraccounts') ? 'activetext' : ''}`}>{t("customersidebar.ACCOUNTSETTING")}</p>
            </Link>
          </li>
          <li onClick={logout}>
          <div className="sidebarlogout">
              <span className="menusideimage"><img className="leftborder" src={logoutdashboard} alt={'icon'} /></span><p>{t("customersidebar.LOGOUT")}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>


    </>

  );
};

export default SideBarsJsx;